module.exports = __webpack_public_path__ + "static/gallery-img-13-db55bbcf5c661d678a2c9d5d5709bb0f.jpg";